export const gaEvent = ({ event, params }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, params)
  } else {
    console.warn('Google Analytics not available - window or gtag undefined')
  }
}

export default () => {
  window.dataLayer = window.dataLayer || []
  function gtag () {
    dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', process.env.GTAG)
}
